const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__iconfinder_square-facebook_317727",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trazado_52",
    d: "M20 18.75A1.25 1.25 0 0118.75 20H1.25A1.25 1.25 0 010 18.75V1.25A1.25 1.25 0 011.25 0h17.5A1.25 1.25 0 0120 1.25z",
    "data-name": "Trazado 52",
    style: {
      fill: "#77777c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__f",
    d: "M18.625 21.875v-7.5h2.5l.625-3.125h-3.125V10A1.658 1.658 0 0120.5 8.125h1.25V5h-2.5c-2.3 0-3.75 1.8-3.75 4.375v1.875H13v3.125h2.5v7.5z",
    transform: "translate(-4.875 -1.875)",
    style: {
      fill: "#f5f5f5"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.9d4b21445e90dd5fb4466bbd45f2e799.svg";
export { ForwardRef as ReactComponent };